'use client'

import React, { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthContext'
import { api } from '../configs/api'

type ContactDataType = {
    id: string
    name: string
    image?: string
    situation?: string
    email?: string
    phone?: string
    company: {
        id: string
        name: string
    }
}

type ContactType = {
    contacts: ContactDataType[]
    setContacts: (value: ContactDataType[]) => void
    filteredContacts: ContactDataType[]
    setFilteredContacts: (value: ContactDataType[]) => void
}

const Contact = createContext<ContactType | undefined>(undefined)

export const ContactProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { unity } = useAuth()
    const [contacts, setContacts] = useState<ContactDataType[]>([])
    const [filteredContacts, setFilteredContacts] = useState<ContactDataType[]>([])

    const loadContacts = async () => {
        if (!unity) return

        const response = await fetch(`${api}contact/getData`, {
            method: 'POST',
            body: JSON.stringify({
                unityID: unity.unityID
            })
        })
        const result = await response.json()

        setContacts(result.contacts)
        setFilteredContacts(result.contacts)
    }

    useEffect(() => {
        //* Carrega contatos
        loadContacts()
    }, [unity])

    return (
        <Contact.Provider
            value={{
                contacts,
                setContacts,
                filteredContacts,
                setFilteredContacts
            }}
        >
            {children}
        </Contact.Provider>
    )
}

export function useContact() {
    const context = useContext(Contact)
    if (context === undefined) {
        throw new Error('useCreate must be used within a ContactProvider')
    }
    return context
}
